import React from 'react';
import './e-select.scss'

const Select = (props) => {
  const {name, value, values, label, onChange, required} = props;
  const optionsListKeys = Object.keys(values);
  const optionsList = optionsListKeys.map((k) => <option className="e-select__option" key={k} value={k}>{values[k]}</option>);

  return (
      <select
        className="e-select"
        required={required}
        value={value}
        name={name}
        id={name}
        onChange={onChange}
      >
        { optionsList }
      </select>
  );
};

export default Select;
